import React, { useContext } from 'react';
import { ZdsPagination } from '@zig-design-system/ui-components-react';
import { UnitContext } from '../../../context/UnitContext';
import { RootContext } from '../../../../Context/RootContext';
import Scroll from '../../../../Shared/Utility/Scroll';
const Pagination = () => {
    const pluginContext = useContext(RootContext).pluginContext;
    const { state, dispatch } = useContext(UnitContext);
    const handlePageChange = (e) => {
        dispatch({ type: 'changePage', value: e.detail.page });
        Scroll.toId('zigrealestate_list');
    };
    const renderPagination = () => {
        const totalPages = Math.ceil(state.totalUnits / pluginContext.itemsPerPage);
        if (totalPages > 1 && !state.loading) {
            return (React.createElement("div", { className: "zds-flex zds-justify-content-center" },
                React.createElement(ZdsPagination, { className: "zds-margin-top-4", onZdsPageChange: handlePageChange, page: state.currentPage, pages: totalPages })));
        }
    };
    return React.createElement(React.Fragment, null, renderPagination());
};
export default Pagination;
